import ModuleView from "@/components/shieldx/ModuleView";
import { BadgeCheck } from "lucide-react";
export default function Verification() {
  return <ModuleView name="verification" icon={BadgeCheck} />;
}
